import { FEATURE_PAYMENTS_WIDGET_FOR_ALL_NATION } from '../constants';
import type { FeatureConfig } from '../types';

export const paymentsWidgetForAllNationFeature: FeatureConfig = {
  name: FEATURE_PAYMENTS_WIDGET_FOR_ALL_NATION,
  toFeature() {
    return {
      name: this.name,
      enabled: false,
    };
  },
};
